module.exports = __webpack_public_path__ + "static/media/norman-mcccan-in-museum.36473c4e.jpg";